import { Locale } from "date-fns";
import { da, enGB, fi, nb, pl, sv } from "date-fns/locale";

import { useOnLanguageChange } from "@/hooks/Translations";

export const useDateFnsLocale = () => {
  const lang = useOnLanguageChange();

  const locales: Record<string, Locale> = {
    da,
    en: enGB,
    fi,
    no: nb,
    pl,
    sv,
  };

  return locales[lang];
};
